const access = (function () {
    let navigation: any = null;
    let isOnline: boolean = true;
    let logout: any = null;
    let authToken: string = '';
    
    const setNavigationAccess = function(val: any) {
        navigation = val
    }

    const getNavigationAccess = function() {
        return navigation;
    }

    const setInternetStatus = function(val: boolean) {
        isOnline = val
    }

    const getInternetStatus = function() {
        return isOnline;
    }

    const setLogoutHandler = function(val: any) {
        logout = val
    }

    const getLogoutHandler = function() {
        return logout;
    }

    const setAuthToken = function(val: string) {
        authToken = val
    }

    const getAuthToken = function() {
        return authToken;
    }

    return {
        setNavigationAccess,
        getNavigationAccess,
        setInternetStatus,
        getInternetStatus,
        setLogoutHandler,
        getLogoutHandler,
        setAuthToken,
        getAuthToken
    }
})()

export default access